<div mat-dialog-title>
    Scan QR Code
    <span class="ml-auto" (click)="closeDialog()" style="float: right;cursor:pointer">
        <i class="fa fa-times" aria-hidden="true"></i>
    </span>

</div>
<div mat-dialog-content style="text-align: center;">
    <img [src]="qr_code_file_path" *ngIf="guid" height="200" width="200">
</div>
<!-- <div class="mat-dialog-actions">
</div> -->
